export default {"src":"/_next/static/media/white_star.d6b5910b.svg","height":10,"width":11};